import { API_ENDPOINTS, API_HEADERS } from '../constants/api';
import { FeaturedPostsResponse } from '../types';

export const fetchFeaturedPosts = async (): Promise<FeaturedPostsResponse | null> => {
  const response = await fetch(API_ENDPOINTS.featuredPosts, {
    headers: API_HEADERS,
  });

  if (!response.ok) {
    throw new Error(`Featured posts request failed with status ${response.status}`);
  }

  const raw = await response.json();
  const data: FeaturedPostsResponse | null =
    Array.isArray(raw) ? (raw.length ? (raw[0] as FeaturedPostsResponse) : null) : raw;

  return data || null;
};

